import Question from "../components/global/questions";
import { db } from "../firebase";
import { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";

const FAQ = () => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const ref = db.collection("blogs/blog/FAQ");
    ref
      .orderBy("createdate", "desc")
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setQuestions(documents);
      });
  }, []);
  console.log(questions);
  return (
    <div className="FAQ">
      <div className="container">
        <h1>الأسئلة الشائعة</h1>
        {questions &&
          questions.map((question) => {
            return (
              <Question key={question.id} name={question.question}>
                {ReactHtmlParser(question.answer)}
              </Question>
            );
          })}
      </div>
    </div>
  );
};

export default FAQ;
